<template>
  <div>
    <v-row>
      <v-col>
        <z-input
          v-model="form.nombre"
          :error-messages="errors.nombre"
          label="Nombre"
          minlength="3"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="8">
        <v-slider
          v-model="form.prioridad"
          :error-messages="errors.prioridad"
          min="1"
          max="100"
          thumb-label="always"
          :thumb-size="24"
          label="Prioridad"
          hint="Se ordenarán desde 1 hasta 100"
        />
      </v-col>
      <v-col cols="4" class="d-flex">
        <v-spacer />
        <z-input
          v-model="form.publicado"
          :error-messages="errors.publicado"
          label="¿Publicado?"
          tipo="checkbox"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ZInput from '@/components/Input/ZInput'
import { mapGetters } from 'vuex'

export default {
  components: { ZInput },
  props: {
    accion: {
      type: String,
    },
    value: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters('app', ['payload']),
    roles() {
      return Object.entries(this.payloadListaRoles).map((v) => ({ name: v[1], id: parseInt(v[0]) }))
    },
    form: {
      get: function () {
        console.log(this.value)
        return this.value
      },
      set: function (value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {},
}
</script>
